export const EMPTY_INGREDIENT = {
    name: "",
    measurement: {
        value: "",
        uom: "",
    },
    purpose: "",
    noteMark: "",
};

export const EMPTY_USE = {
    text: "",
    bullets: [],
};

export const EMPTY_WARNING = {
    type: "",
    text: "",
    bullets: [],
};

export const EMPTY_USERGROUP = {
    userGroup: "",
    directions: "",
};

export const DEFAULT_DRUG_PANEL = () => {
    return {
        servingText: "",
        activeIngredients: [],
        uses: [],
        warnings: [],
        directions: [],
        userGroups: [],
        footnotes: {},
        otherInformation: [],
        inactiveIngredients: [],
        comments: "",
        additionalDetails: "",
    };
};
